<script setup lang="ts">
import HandleQueryStatus from "@/components/HandleQueryStatus.vue";
import MainLogo from "@/components/MainLogo.vue";
import { useGetSettings } from "@/settings/settingsCrud";
import { OpenNewWindow } from "@iconoir/vue";
const { settings, getSettingsStatus } = useGetSettings();
</script>
<template>
  <div class="cover">
    <div class="container container-md box column column-xl">
      <header class="column column-lg">
        <MainLogo class="logo center" />

        <section class="organisation">
          <h2 class="visually-hidden">Organisation</h2>
          <p>{{ $config.organizationName }}</p>
        </section>
      </header>
      <main>
        <slot />
      </main>
      <footer>
        <nav aria-labelledby="footer-nav-label">
          <h2 id="footer-nav-label" class="visually-hidden">
            Footernavigation
          </h2>
          <HandleQueryStatus :query-status="getSettingsStatus">
            <ul role="list" class="row row-center">
              <li>
                <a
                  :href="settings?.privacyPolicyUrl"
                  class="footer-nav-link"
                  aria-label="Datenschutzerklärung - Link öffnet einen neuen Tab"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  <OpenNewWindow />Datenschutz
                </a>
              </li>
              <li>
                <a
                  :href="settings?.impressUrl"
                  class="footer-nav-link"
                  aria-label="Impressum - Link öffnet einen neuen Tab"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  <OpenNewWindow />Impressum
                </a>
              </li>
            </ul>
          </HandleQueryStatus>
        </nav>
      </footer>
    </div>
  </div>
</template>

<style scoped>
.cover {
  block-size: 100vh;
}

.logo {
  display: block;
  width: 60%;
}

.organisation {
  h2 {
    font-size: var(--font-size-default);
    font-weight: var(--font-weight-default);
  }

  p {
    font-size: var(--font-size-h2);
    font-weight: var(--font-weight-h2);
  }
}

img[alt="Kiezkompass"] {
  max-inline-size: 10rem;
}

.footer-nav-link {
  display: flex;
  align-items: center;
  gap: 0.2rem;
}
</style>
